import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';


class DetailResult extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            item: {
                summary: '',
                report: '',
            },
        };
        this.inputsRef = new Set();
        this.ref = React.createRef();
        // this.defaultState = _.cloneDeep(this.state.user);
    }


    componentDidUpdate() {
        window.LadiUI.init();
    }

    componentWillReceiveProps(nextProps) {
        // console.log(nextProps.url, this.state.actionObj.url);
        if (nextProps.item != this.state.item) {
            this.setState({
                item: nextProps.item,
            })
        }

    }



    render() {
        const { actionObj, selectedAction } = this.state;


        const title = 'Detail Result';

        return (
            <div ref={this.ref} id="modal-detail-result" className="ladiui-modal fade" tabIndex={-1} data-dismiss="modal-detail-result"
                onClick={this.resetForm}>
                <div className="ladiui-modal-content" >
                    <div className="ladiui-modal-header"><button type="button" className="ladiui-close-modal" data-dismiss="modal-detail-result"><i className="ladi-icon icon-e-remove" data-dismiss="modal-detail-result" /></button>
                        <h3>{title}</h3>
                    </div>
                    <div className="ladiui-modal-body" >
                        {/* <form> */}
                        <div className="ladiui-tab-content" style={{ height: "360px" }}>

                            <div className="ladiui-row">
                                <div className="ladiui form-group">
                                    <label className="ladiui-label">Summary</label>
                                    <textarea
                                        style={{ height: "100px", width: "100%" }}
                                        value={this.state.item.summary}
                                        readOnly
                                    />
                                </div>
                                <div className="ladiui form-group">
                                    <label className="ladiui-label">Report</label>
                                    <textarea
                                        style={{ height: "300px", width: "100%" }}
                                        value={this.state.item.report}
                                        readOnly
                                    />
                                </div>

                            </div>

                        </div>
                        {/* </form> */}
                    </div>
                    <div className="ladiui-modal-footer">
                        <button className="ladiui button secondary close-modal icon" data-dismiss="modal-detail-result">
                            <i className="ladi-icon icon-e-remove" data-dismiss="modal-detail-result" />Đóng
                        </button>
                    </div>
                </div>
            </div >
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

const mapStateToProps = (state) => ({ ...state.tool });

export default connect(mapStateToProps, mapDispatchToProps)(DetailResult);